import PropTypes from 'prop-types';

const componentPropTypes = {
  reservationData: PropTypes.shape({
    id: PropTypes.number,
    contract: PropTypes.object,
    rateCode: PropTypes.string,
    fromDate: PropTypes.string
  }).isRequired,
  readOnly: PropTypes.bool,
  contractsList: PropTypes.arrayOf(PropTypes.object),
  contractDetailList: PropTypes.arrayOf(PropTypes.object),
  hotelCode: PropTypes.string,
  tourOperator: PropTypes.string,
  loadFullContractData: PropTypes.func,
  updateReservationContract: PropTypes.func,
  handleModalMessages: PropTypes.func
};

const componentDefaultProps = {
  readOnly: false,
  contractsList: [],
  contractDetailList: [],
  hotelCode: '',
  tourOperator: '',
  loadFullContractData: () => {},
  updateReservationContract: () => {},
  modalManager: () => {},
  handleModalMessages: () => {}
};

export { componentPropTypes, componentDefaultProps };
